// extracted by mini-css-extract-plugin
module.exports = {"modal":"SearchWidget_modal__IjT1W","wrapper":"SearchWidget_wrapper__rJYX0","backdrop":"SearchWidget_backdrop__9lsbP"};